import { type MediaApiGateway } from "@modules/common/media/api/mediaApiGateway"
import { type MediaUploadInformation } from "@modules/common/media/mediaTypes"
import { Config } from "@modules/config"
import { ApiClient } from "@modules/core/api/client/apiClient"

export class MediaApi implements MediaApiGateway {
  constructor(private api: ApiClient) {}

  async getUploadInformation(mediaType: string) {
    if (typeof Config.AWS_VIDEO_UPLOAD === "string" && Config.AWS_VIDEO_UPLOAD.length > 0) {
      const resultDto = await this.api.post<MediaUploadInformation>(Config.AWS_VIDEO_UPLOAD, {
        contentType: mediaType,
      })
      return resultDto.data
    }
    throw new Error("AWS_VIDEO_UPLOAD is not a string")
  }

  async uploadFile(file: File, uploadInformation: MediaUploadInformation) {
    const data = {
      ...uploadInformation.data.fields,
      file,
    }
    const formData = new FormData()

    for (const [name, value] of Object.entries(data)) {
      formData.append(name, value as string | Blob)
    }

    await fetch(uploadInformation.data.url, {
      method: "POST",
      body: formData,
    })
  }
}
